<template>
  <div class="default-layout">
    <Header />
    <main>
      <slot />
    </main>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'Default',
  components: {
    Header
  }
};
</script>

<style lang="scss" scoped>
.default-layout {
  height: 100%;
  min-height: 100vh;
}

main {
  height: 100%;
  padding-top: 100px;
  padding-bottom: 45px;

  @media print {
    padding-top: 25px;
    padding-bottom: 0;
  }
}
</style>
